import createIcon from '../../createIcon';

/**
 * @component @name Church
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTIuNzJWOS41TDEzIDdWNS41SDE1VjMuNUgxM1YxLjVIMTFWMy41SDlWNS41SDExVjdMNiA5LjVWMTIuNzJMMiAxNC41VjIyLjVIMTBWMTkuNUMxMCAxOC40IDEwLjkgMTcuNSAxMiAxNy41QzEzLjEgMTcuNSAxNCAxOC40IDE0IDE5LjVWMjIuNUgyMlYxNC41TDE4IDEyLjcyWk0xMiAxNEMxMS4xNyAxNCAxMC41IDEzLjMzIDEwLjUgMTIuNUMxMC41IDExLjY3IDExLjE3IDExIDEyIDExQzEyLjgzIDExIDEzLjUgMTEuNjcgMTMuNSAxMi41QzEzLjUgMTMuMzMgMTIuODMgMTQgMTIgMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Church = createIcon('Church', [
  [
    'path',
    {
      d: 'M18 12.72V9.5L13 7V5.5H15V3.5H13V1.5H11V3.5H9V5.5H11V7L6 9.5V12.72L2 14.5V22.5H10V19.5C10 18.4 10.9 17.5 12 17.5C13.1 17.5 14 18.4 14 19.5V22.5H22V14.5L18 12.72ZM12 14C11.17 14 10.5 13.33 10.5 12.5C10.5 11.67 11.17 11 12 11C12.83 11 13.5 11.67 13.5 12.5C13.5 13.33 12.83 14 12 14Z',
      key: '1eu7b8',
    },
  ],
]);

export default Church;
